import React from 'react';
import { Transition } from 'react-transition-group';
import { StyledBackdrop } from './Overlay.styles';
export const Overlay = ({ children, open = false, backdrop = false, transitionDuration = 200, ...restProps }) => {
    return (React.createElement(Transition, { timeout: { enter: transitionDuration, exit: transitionDuration }, in: open, mountOnEnter: true, unmountOnExit: true, ...restProps }, (status) => {
        const open = status === 'entering' || status === 'entered';
        return (React.createElement(React.Fragment, null,
            backdrop && (React.createElement(StyledBackdrop, { open: open, transitionDuration: transitionDuration })),
            React.Children.map(children, (child) => child &&
                React.cloneElement(child, {
                    open,
                    transitionDuration,
                }))));
    }));
};
//# sourceMappingURL=Overlay.js.map